import React, { useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import TertiaryButton from "../../../components/buttons/tertiary-button";
import { IoClose } from "react-icons/io5";


const Modal = ({
    externalControl,
    className,
    status,
    title,
    icon,
    subtitle,
    body,
    primaryButton,
    buttonLabel,
    buttonClassName,
    bodyButton,
    bodyButtonLabel,
    onClose,
    onOpen,
    bodyButtonClassName,
}) => {
    let [isOpen, setIsOpen] = useState(false);

    function closeModal() {
        setIsOpen(false);
        if (onClose != null) {
            onClose();
        }
    }

    function openModal() {
        setIsOpen(true);
        if (onOpen != null) {
            onOpen();
        }
    }
    useEffect(() => {
        if (externalControl === true) {
            status ? openModal() : closeModal();
        }
    });

    return (
        <>
            {!externalControl && (
                <>
                    {primaryButton ? (
                        <TertiaryButton
                            onClick={openModal}
                            content={buttonLabel}
                            className={buttonClassName}
                        />
                    ) : (
                        <TertiaryButton
                            onClick={openModal}
                            content={buttonLabel}
                            className={buttonClassName}
                        />
                    )}
                </>
            )}

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-9999" onClose={closeModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 background-black bg-opacity-25"/>
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex items-center justify-center min-h-full p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className={
                                        className ? className : "" +
                                        " modal-resetPassword d-inline-block p-4 py-3 pt-8 text-start align-items-center transition translate rounded"
                                    }
                                >
                                    <Dialog.Title
                                        as="h2"
                                        className="d-flex justify-content-between"
                                    >
                                        <div className="d-flex">{icon}<span className="borderBox mt-[3px]">{title}</span></div>
                                        {!bodyButton && (
                                            <button
                                                type="button"
                                                className={
                                                    externalControl
                                                        ? "d-none "
                                                        : "d-inline-flex justify-content-end w-50 h-100 btnClosePassword"
                                                }
                                                onClick={closeModal}
                                            >
                                                <IoClose className="w-full h-auto"/>
                                            </button>
                                        )}
                                    </Dialog.Title>
                                    {subtitle && (
                                        <div className="mt-4">
                                            <p>
                                                {subtitle}
                                            </p>
                                        </div>
                                    )}
                                    <div className="mt-6">
                                        <div>{body}</div>
                                    </div>
                                    {bodyButton && (
                                        <div className={bodyButtonClassName + " mt-4 w-full"}>
                                            <button
                                                type="button"
                                                className={"text-white d-inline-flex justify-content-center px-4 py-2 btn-sm border-0 rounded hover:brightness-95 focus-visible focus-visible:ring focus-visible:ring-primary focus-visible:ring-offset-2"
                                                }
                                                onClick={closeModal}
                                            >
                                                {bodyButtonLabel}
                                            </button>
                                        </div>
                                    )}
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
};

export default Modal;
